import { render, staticRenderFns } from "./IconRecord.vue?vue&type=template&id=7b470e97&"
import script from "./IconRecord.vue?vue&type=script&lang=js&"
export * from "./IconRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b470e97')) {
      api.createRecord('7b470e97', component.options)
    } else {
      api.reload('7b470e97', component.options)
    }
    module.hot.accept("./IconRecord.vue?vue&type=template&id=7b470e97&", function () {
      api.rerender('7b470e97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconRecord.vue"
export default component.exports